/*Redirecting landing and custom pages*/
var abc = "https://oakvalleydesigns.com/";
var currentURL = jQuery(location).attr("href")
/*custom page redirection*/
if(currentURL == 'https://oakvalleydesigns.com/custom'){

window.location.href = "https://oakvalleydesigns.com/pages/custom ";
  /*landing page redirection*/
}else if(currentURL == 'https://oakvalleydesigns.com/landing'){
 window.location.href = "https://oakvalleydesigns.com/collections/carpet-landings";
} else if(currentURL.includes('https://oakvalleydesigns.com/products/tiburon') || currentURL == 'https://oakvalleydesigns.com/products/valencia'
       || currentURL == 'https://oakvalleydesigns.com/products/oakvalleywoolropestripe' || 
       currentURL == 'https://oakvalleydesigns.com/products/patna' || currentURL.includes('https://oakvalleydesigns.com/products/new-oak-valley-striated-square-tread') || 
       currentURL.includes('https://oakvalleydesigns.com/products/boho-stripe') || currentURL.includes('https://oakvalleydesigns.com/products/cherish')) {
      window.location.href = "https://oakvalleydesigns.com/collections/treads";
} else {
  //console.log('working');
}


/*-----------------------prevent large image from loading in mobile--------------------------*/
/*$(document).ready(function() {
  $('.hidden-pocket img').removeAttr("src");
  $('.hidden-pocket img').removeAttr("srcset");
})*/

/*-----------------------------------Social Landing -----------------------------------------*/
$(document).ready(function() {
  //Get the url of the page
  let path = window.location.href;
  //Check if the page is social-landing by checking if the url includes the text 'social-landing'
  if(path.includes('social-landing')) {
    //Add a class that we can target to make css adjustments just to the social-landing page without affecting the rest of the site
    $('body').addClass('social-landing');
  }
});


// 0P1-T601: Add a new header image and make it clickable
// Check if it's the homepage
$(document).ready(function() {
if (window.location.pathname === "/") {
  
  // Select the 1st slideshow element on home page only
  const slideshowSlide = document.querySelector(".slideshow__slide");

  // Check if the element exists
  if (slideshowSlide) {
    console.log("Homepage: Error");
    // Add the pointer cursor style
    slideshowSlide.style.cursor = "pointer";

    // Add the onclick event handler
    slideshowSlide.onclick = function() {
      window.location.href = "https://oakvalleydesigns.com/collections/treads"; // Redirect to the desired link
    }; //close the function
  } // end if statement
} // end main if statement
});


// --------------[0C2-T65: Fix read more button on collections pages - 26.Sept.2024 (updated to hardcode: 30.Sept.2024)]----------------------------------- //
// Check if the current page URL includes "collections" and does NOT include "/free-samples"
if (window.location.pathname.includes("collections") && !window.location.pathname.includes("/free-samples")) { // Opening of if statement

  var textData = [ // Array of objects to store different content based on URL keywords
     {
      // First object for "treads" keyword
      keyword: "/treads", // Keyword to look for in URL
      firstSentence: `<a href="https://oakvalleydesigns.com/">Oak Valley Designs</a> offers luxury padded carpet stair treads crafted from materials like wool and sisal—customized to fit your staircase. Matching landings and hallway runner rugs are also available in several sizes and help bring a cohesive look to your space.`, // First part of the content
      readMore: `<br/><br/>Enjoy the comfort, elegance, and ease of our seamlessly installed bullnose stair treads, designed to enhance both the style and safety of your stairs without the hassles and cost of a traditional stair runner.
      <br/><br/>Customers often call them “the premier carpet stair treads”—and for good reason. With simple peel-and-stick installation, upgrading your staircase has never been easier. Whether <a href="https://oakvalleydesigns.com/blogs/buyers-guide/where-to-buy-stair-treads">you’re looking for guidance</a> or are ready to purchase new stair treads, <a href="https://oakvalleydesigns.com/blogs/buyers-guide">you’ve come to the right place.</a>` // Additional content for "Read More"
    }, // Closing first object
    {
      // Second object for "wool-stair-treads" keyword
      keyword: "wool-stair-treads", // Keyword to look for in URL
      firstSentence: `At <a href="https://oakvalleydesigns.com/">Oak Valley Designs</a>, our wool stair treads offer a natural, environmentally friendly fiber solution that’s exceptionally durable and resistant to everyday wear and soiling. Whether for stairs, landings, or hallway runners, wool is a practical and stylish choice. `, // First part of the content
      readMore: `<br/><br/>
      Our padded wool bullnose treads make every step more enjoyable—braided for strength, designed for comfort, and crafted with luxury in mind. 
      <br/><br/>
      If you're looking to enhance your stairs with the elegance of wool but want a <a href="https://oakvalleydesigns.com/blogs/buyers-guide/how-much-do-stair-treads-cost">cost-effective</a>, alternative to a traditional runner, our innovative wool stair treads are the perfect solution.` // Additional content for "Read More"
    }, // Closing second object
    {
      // Third object for "natural-fiber-treads" keyword
      keyword: "natural-fiber-treads", // Keyword to look for in URL
      firstSentence: `Naturally timeless. Made from 100% natural and biodegradable fibers, sisal and jute carpet stair treads are known for their durability, allergy-friendly properties, and exceptional performance in high-traffic areas. `, // First part of the content
      readMore: `<br/><br/>At <a href="https://oakvalleydesigns.com/">Oak Valley Designs</a>, we craft luxurious stair treads and rugs from premium materials like wool, sisal, and jute— customized to fit your staircase. Don’t forget to add coordinating rugs for staircase landings and hallways. ` // Additional content for "Read More"
    }, // Closing third object
    {
      // Fourth object for "indoor-outdoor-treads" keyword
      keyword: "indoor-outdoor-treads", // Keyword to look for in URL
      firstSentence: `Oak Valley Designs crafts stylish, durable carpet stair treads—along with matching landings and hallway runners—built to perform both indoors and out. `, // First part of the content
      readMore: `<br/<br/><br/>Fashion-forward and budget-friendly, these treads thrive in high-traffic areas, are softer than you'd expect, and are easy to clean. Woven from long-lasting polypropylene, they’re an ideal choice for outdoor stairs and hallways that demand both comfort and durability. ` // Additional content for "Read More"
    }, // Closing fourth object
    {
      // Fifth object for "synthetic-carpet-treads" keyword
      keyword: "synthetic-carpet-treads", // Keyword to look for in URL
      firstSentence: `Polypropylene is a family-friendly carpet fiber that’s easy to clean, highly stain-resistant, durable, and budget-friendly—making it a smart choice for busy homes. `, // First part of the content
      readMore: `<br/><br/>Even your furry friends will love the comfort of our synthetic stair treads. The hardest part is deciding which <a href="https://oakvalleydesigns.com/">Oak Valley Designs’</a> <a href="https://oakvalleydesigns.com/blogs/buyers-guide/what-type-of-stair-tread-do-i-need">style to choose</a>.` // Additional content for "Read More"
    }, // Closing fifth object
    {
      // Sixth object for "carpet-landings" keyword
      keyword: "carpet-landings", // Keyword to look for in URL
      firstSentence: `Elevate your staircase with <a href="https://oakvalleydesigns.com/">Oak Valley Designs’</a> elegant and functional carpet stair landings. Thoughtfully crafted to enhance both style and utility, our landings protect high-traffic areas while adding a seamless, finished look—especially when paired with our matching stair treads for the effect of a traditional runner. `, // First part of the content
      readMore: `<br/><br/>Available in a variety of luxurious materials, from plush wool to durable sisal, these landings suit any interior style. They offer cushioned comfort, reduce noise, and protect stairs from everyday wear—all while enhancing the overall safety and visual appeal of your home.` // Additional content for "Read More"
    }, // Closing sixth object
    {
      // Seventh object for "runner-rugs" keyword
      keyword: "runner-rugs", // Keyword to look for in URL
      firstSentence: `Designed to enhance visual flow and bring harmony between stairs and hallways, these runners add warmth, elegance, and a polished touch to any space. Available in a wide range of textures and materials—from soft wool to durable synthetics—they suit every style, from classic to contemporary. `, // First part of the content
      readMore: `<br/><br/>More than just decorative, our hallway runners help protect flooring, reduce noise, and provide a cushioned, comfortable surface underfoot. Crafted for long-lasting durability and easy upkeep, they’re a smart, stylish investment in your home’s comfort and charm. 
<br/><br/>
Pair them with our stair treads for a cohesive interior that’s as functional as it is refined. With Oak Valley Designs, every step tells a story of harmony, comfort, quality, and timeless design.` // Additional content for "Read More"
    }, // Closing seventh object
    {
      // 8th object for "new-styles" keyword
      keyword: "new-styles", // Keyword to look for in URL
      firstSentence: `Oak Valley Designs is proud to launch these beautiful new styles of premium carpet stair treads-customized to fit your staircase. `, // First part of the content
      readMore: `Complete the look with coordinating rugs for landings and hallways in a range of sizes.` // Additional content for "Read More"
    } // Closing seventh object
  ]; // Closing textData array

  
//   // Data object containing keywords, firstSentence, and readMore text
//   var textData = [ // Array of objects to store different content based on URL keywords
//     {
//       // First object for "treads" keyword
//       keyword: "/treads", // Keyword to look for in URL
//       firstSentence: `<a href="https://oakvalleydesigns.com/">Oak Valley Designs</a> creates luxurious carpet stair treads from wool to sisal for any shape or size staircase along with matching rugs for various size landings and hallways.`, // First part of the content
//       readMore: `Enjoy the luxury, comfort and simplicity of our seamlessly installed bullnose stair treads.<br/><br/>
//       Experience the blend of tranquility and refined beauty these treads add to your home, elevating both its safety and aesthetic appeal, all without the difficulty of a traditional stair runner.
//       <br/><br/>Many of our customers are excitedly saying these are, "the best carpet stair treads". And a big reason for their excitement is because these are easy to install, peel and stick carpet stair treads, unlike a carpet stair runner. Learn more about <a href="https://oakvalleydesigns.com/blogs/buyers-guide/where-to-buy-stair-treads">where to buy stair treads</a> for your home by reading our <a href="https://oakvalleydesigns.com/blogs/buyers-guide">stair tread buyer's guide</a>.` // Additional content for "Read More"
//     }, // Closing first object
//     {
//       // Second object for "wool-stair-treads" keyword
//       keyword: "wool-stair-treads", // Keyword to look for in URL
//       firstSentence: `At <a href="https://oakvalleydesigns.com/">Oak Valley Designs</a>, our wool stair treads are a great environment friendly natural fiber that offers superb resilience to wear and general soiling.`, // First part of the content
//       readMore: `For stairs, landing or hallways a hardwearing practical carpet like wool is ideal.
//       <br/><br/>
//       Our padded wool carpet stair treads make traversing the stairs an enjoyable experience again. The wool is braided, durable and designed for maximum comfort and luxury.
//       <br/><br/>
//       If you're considering <a href="https://oakvalleydesigns.com/blogs/buyers-guide/how-much-do-stair-treads-cost">stair cover cost</a>, but are still seeking luxury, our wool bullnose carpet stair treads are an innovative alternative to a traditional wool stair runner.` // Additional content for "Read More"
//     }, // Closing second object
//     {
//       // Third object for "natural-fiber-treads" keyword
//       keyword: "natural-fiber-treads", // Keyword to look for in URL
//       firstSentence: `Simply timeless. 100% natural and biodegradable, sisal & jute carpets are known for durability and work excellent in high-traffic areas while good for people with allergies.`, // First part of the content
//       readMore: `<br/><br/>Oak Valley Designs creates luxurious carpet stair treads from wool to sisal for any shape or size staircase along with matching rugs for various size landings and hallways.` // Additional content for "Read More"
//     }, // Closing third object
//     {
//       // Fourth object for "natural-fiber-treads" keyword (duplicated keyword)
//       keyword: "indoor-outdoor-treads", // Keyword to look for in URL
//       firstSentence: `Oak Valley Designs creates luxurious yet durable carpet stair treads that are good for both indoor and outdoor use.`, // First part of the content
//       readMore: `<br/<br/><br/>Fashion forward for less. Loves high traffic areas. Softer than you think. A breeze to clean. Woven from polypropylene for incredible endurance, making them the perfect covering for outdoor stairs.` // Additional content for "Read More"
//     }, // Closing fourth object
//     {
//       // Fifth object for "synthetic-carpet-treads" keyword
//       keyword: "synthetic-carpet-treads", // Keyword to look for in URL
//       firstSentence: `Polypropylene is a great 'family friendly' carpet fiber option that is easy to clean, highly stain resistant, durable and good value for your money.`, // First part of the content
//       readMore: `<br/><br/>Your furry friends will be delighted about our synthetic stair treads.
//       <br/><br/>
//       <a href="https://oakvalleydesigns.com/">Oak Valley Designs</a> is here to help you in your search for the perfect stair treads. If you're wondering if synthetic carpet is right for you, check out this guide about what type of <a href="https://oakvalleydesigns.com/blogs/buyers-guide/what-type-of-stair-tread-do-i-need">stair tread to choose</a>.` // Additional content for "Read More"
//     }, // Closing fifth object
//     {
//       // Sixth object for "carpet-landings" keyword
//       keyword: "carpet-landings", // Keyword to look for in URL
//       firstSentence: `Transform your staircase with Oak Valley Designs' elegant and functional carpet stair landings.`, // First part of the content
//       readMore: `Our meticulously crafted landings not only enhance the look of your home but also offer practical benefits like protecting high-traffic areas. Combine with stair treads to have the a look similar to a traditional stair runner.
// <br/><br/>
// Available in a variety of luxurious materials, from plush wool to robust sisal, these pieces are designed to complement any interior style and fit seamlessly into your staircase design. They provide a cushioned transition between steps, reduce noise, and safeguard your stairs against wear, blending practicality with visual appeal.
// <br/><br/>
// Our collection ranges from timeless traditional designs to contemporary styles, ensuring there's a perfect match for every preference. Crafted with durability and ease of maintenance in mind, our stair landing rugs are not just long-lasting but also enhance the safety and value of your home. Elevate your space with a touch of sophistication and functionality with our unique stair solutions, and experience the perfect fusion of style and comfort.` // Additional content for "Read More"
//     }, // Closing sixth object
//     {
//       // Seventh object for "runner-rugs" keyword
//       keyword: "runner-rugs", // Keyword to look for in URL
//       firstSentence: `Oak Valley Designs' Carpet Hallway Runners offer the perfect blend of style and functionality, seamlessly complementing your carpet stair treads.`, // First part of the content
//       readMore: `These runners not only enhance the visual continuity between your stairs and hallways but also add a layer of sophistication to your space.
// <br/><br/>
// Available in a variety of textures and materials, they cater to all decor preferences, ensuring a harmonious look throughout your home. Beyond their aesthetic appeal, these runners protect your floors, reduce noise, and provide a comfortable walking experience, proving to be both a beautiful and practical addition to your home.
// <br/><br/>
// Our Hallway Runners are designed with an eye for elegance and a focus on durability. They complement various interior styles, from modern to traditional, and are easy to maintain, making them a long-lasting feature in your home. Integrating these runners with our stair treads creates a unified and inviting atmosphere, enhancing the overall charm and appeal of your living space. Choose Oak Valley Designs for a sophisticated, cohesive home interior` // Additional content for "Read More"
//     } // Closing seventh object
//   ]; // Closing textData array

  // Function to get text based on URL keyword
  function getTextByKeyword() { // Function declaration
    for (var i = 0; i < textData.length; i++) { // Loop through each item in textData array
      if (window.location.pathname.includes(textData[i].keyword)) { // Check if current URL includes the keyword
        return textData[i]; // Return the matching object if found
      } // Closing if
    } // Closing for loop
    return null; // Return null if no match is found
  } // Closing function

  // Get the relevant text data based on URL
  var selectedText = getTextByKeyword(); // Call the function to retrieve text based on URL
  
  if (selectedText) { // Check if text data was found for the current URL
    $(document).ready(function () { // Wait until the document is ready

      // Select the paragraph inside the specified container
      var $paragraph = $(".image-overlay__text-container p"); // Store the paragraph element
      var $button = $("section > div > image-with-text-overlay > div.container > div > div > div > a"); // Store the button element

      var firstSentence = selectedText.firstSentence; // Store the first sentence from the selected text
      var readMore = selectedText.readMore; // Store the additional "read more" text

      // Set the paragraph content to the first sentence followed by the remaining text
      $paragraph.html('<span class="more-text">' + readMore + '</span>'); // Insert first sentence and hidden remaining text

      // Initially hide the rest of the text
      var $moreText = $paragraph.find(".more-text"); // Find the span containing the rest of the text
      $moreText.css({ visibility: 'hidden' }); // Initially hide the additional text using CSS visibility

      // Calculate the collapsed and expanded heights
      var fullPHeight = $paragraph.get(0).scrollHeight; // Get the full height of the paragraph
      $paragraph.css('height', 'auto'); // Reset the height to auto to allow full expansion

      $paragraph.html(firstSentence); // Set the paragraph content to the first sentence only
      var collapsedHeight = $paragraph.get(0).scrollHeight; // Calculate the height of the collapsed paragraph

      function calculateFullHeight() { // Function to calculate the full height of the paragraph
        $moreText.css({ display: 'inline' }); // Temporarily show the full text
        var fullPHeight = $paragraph.get(0).scrollHeight; // Get the full height with all text visible


        $moreText.css({ display: 'none' }); // Hide the full text again
        return fullPHeight; // Return the full height
      } // Closing function

      // Reset the paragraph to its full content and apply collapsed height initially
      $paragraph.html(firstSentence + '<span class="more-text">' + readMore + '</span>'); // Restore full paragraph content
      $paragraph.css({
        height: collapsedHeight, // Set the paragraph to its collapsed height
        overflow: 'hidden', // Hide overflow to avoid displaying hidden text
      }); // Apply CSS properties

      var isCollapsed = true; // Flag to track whether the text is collapsed or expanded

      $button.click(function (e) { // Attach a click event handler to the button
        e.preventDefault(); // Prevent default anchor behavior
        if (isCollapsed) { // If text is collapsed
          $moreText.css({ visibility: 'visible' }); // Make the additional text visible
          var fullPHeight = calculateFullHeight(); // Get the full height of the paragraph
          $paragraph.animate({ height: fullPHeight }, 500, function () { // Animate to expand the paragraph
            $paragraph.css('height', fullPHeight); // Set the height to the full height
          }); // End of animation callback
          $button.text("Read Less"); // Change button text to "Read Less"
        } else { // If text is expanded
          $paragraph.animate({ height: collapsedHeight }, 500, function () { // Animate to collapse the paragraph
            $moreText.css({ visibility: 'hidden' }); // Hide the additional text
          }); // End of animation callback
          $button.text("Read More"); // Change button text to "Read More"
        } // End of if-else
        isCollapsed = !isCollapsed; // Toggle the collapsed/expanded state
      }); // End of click event handler
    }); // End of document ready function
  } // End of if selectedText check
} // End of main if condition





// 0C2-T72: Reposition Mobile Landing Page Sections (Fall back for css if the video gets too tall on the larger screens)

// Add an event listener for the 'resize' event
// This ensures the scaling logic runs whenever the window is resized
window.addEventListener('resize', () => {
    // Select the external-video custom element
    const externalVideo = document.querySelector('external-video');

    // Check if external-video exists and contains an iframe
    if (externalVideo) {
        const videoElement = externalVideo.querySelector('iframe'); // selecting the iframe within the element

        if (videoElement) { // Ensure iframe exists
            if (window.innerWidth > 2070) { // checking if screenwidth is larger than 2070px
                const scale = 1.5 + (window.innerWidth - 2070) / 1000; // scaling the video based on screen width to prevent black bars on the sides
                videoElement.style.transform = `scale(${scale})`; // applying the scale to the video
                videoElement.style.transformOrigin = 'center'; // keep the video centered
            } else { // else if the screensize is less or equal to 2070px
                videoElement.style.transform = 'scale(1)'; // not scaling the video element
            } // end if else
        } // end if
    } // end if
}); // end event listener


// Manually trigger the 'resize' event when the page loads
// This ensures the scaling logic runs immediately after the page is loaded
const intervalId = setInterval(() => { // setting interval of 0.5 secs to make sure it runs
  if (document.querySelector('external-video iframe')) { // checking if element exits
    window.dispatchEvent(new Event('resize')); // dispacthing the event
    clearInterval(intervalId); // Clear the interval once the condition is met
  } //end if
}, 500); // end setInterval